import React, { ReactNode } from "react";

export interface CustomIconProps {
  path: ReactNode;
  viewboxDefault?: [number, number];
  size?: [number, number];
  defs?: ReactNode[];
}

export const customIcon = ({ path, defs = [], size = [20, 20], viewboxDefault = [20, 20] }: CustomIconProps) => {
  return (
    <span className="bp4-icon">
      <svg version="1.1" width={size[0]} height={size[1]} viewBox={`0 0 ${viewboxDefault[0]} ${viewboxDefault[1]}`}>
        {defs.map((def, idx) => (
          <defs key={idx}>{def}</defs>
        ))}
        {path}
      </svg>
    </span>
  );
};
